import React from "react";
import PartnerSectionView from "src/pages/section/PartnerSection/view";

export interface PartnerSectionProps {}

function PartnerSection(props: PartnerSectionProps) {
    const handleOpenFile = (filePath: string) => {
        window.open(filePath, '_blank');
    };

    return (
        <PartnerSectionView
            {...props}
            onPartnershipClick={() => handleOpenFile("https://bimg.eventu.co.kr/ir/EventU_Service_Partnership_Introduction_DataUniverse.pdf")}
            onProposalClick={() => handleOpenFile("https://bimg.eventu.co.kr/ir/EventU_Biz_Solution_Proposal_DataUniverse.pdf")}
        />
    );
}

export default PartnerSection;